import { useState, useEffect } from "react";
import { saveDeduction, fetchWorkingDaysIds, fetchResourceIds } from "../Api/DeductionMaster";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

import "../Styling/Accordion.css";
import "../Styling/Title.css";
import "../Styling/SaveButton.css";

const DeductionMaster = () => {
  const [loading, setLoading] = useState(false);
  const [workingDaysIds, setWorkingDaysIds] = useState([]);
  const [resourceIds, setResourceIds] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();

  const [deductionData, setDeductionData] = useState({
    workingDaysId: "",
    resourceId: "",
    deductionType: "",
    deductionAmount: "",
    payrollid: "",
    companycode: user?.companyCode,
    organisation_Id: user?.organisationId,
  });

  const deductionTypes = ["TDS", "Advance", "Asset", "Leave","Loan"];

  useEffect(() => {
    const fetchIds = async () => {
      try {
        const [workingDays, resources] = await Promise.all([
          fetchWorkingDaysIds(user.organisationId),
          fetchResourceIds(user.organisationId),
        ]);
        setWorkingDaysIds(workingDays);
        setResourceIds(resources);
      } catch (err) {
        toast.error("Error loading IDs");
      }
    };
    fetchIds();
  }, [user.organisationId]);

  const handleChange = (e) => {
    setDeductionData({ ...deductionData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      ...deductionData,
      companycode: user.companyCode,
      organisation_Id: user.organisationId,
      deductionAmount: Number(deductionData.deductionAmount),
    };
    try {
      await saveDeduction(payload);
      toast.success("Deduction saved successfully!");
      navigate("/view-deductions");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error saving data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">
      <h2 className="fields-title">Deduction Master</h2>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">
        <Accordion defaultActiveKey="0" className="asset-master-accordion">
          <AccordionItem eventKey="0">
            <AccordionBody>
              <Row className="g-3">
                {/* Working Days ID */}
                <Col xl={4} lg={6} md={6} sm={12}>
                  <Form.Group controlId="workingDaysId">
                    <Form.Label>Working Days ID</Form.Label>
                    <Form.Select
                      name="workingDaysId"
                      value={deductionData.workingDaysId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Working Days ID</option>
                      {workingDaysIds.map((w) => (
                        <option key={w.workingDaysId} value={w.workingDaysId}>
                          {w.workingMonth}-{w.workingYear}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Resource ID */}
                <Col xl={4} lg={6} md={6} sm={12}>
                  <Form.Group controlId="resourceId">
                    <Form.Label>Resource ID</Form.Label>
                    <Form.Select
                      name="resourceId"
                      value={deductionData.resourceId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Resource ID</option>
                      {resourceIds.map((r) => (
                        <option key={r.resourceId} value={r.resourceId}>
                          {r.resourceId} - {r.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Deduction Type */}
                <Col xl={4} lg={6} md={6} sm={12}>
                  <Form.Group controlId="deductionType">
                    <Form.Label>Deduction Type</Form.Label>
                    <Form.Select
                      name="deductionType"
                      value={deductionData.deductionType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Type</option>
                      {deductionTypes.map((t) => (
                        <option key={t} value={t}>
                          {t}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Deduction Amount */}
                <Col xl={4} lg={6} md={6} sm={12}>
                  <Form.Group controlId="deductionAmount">
                    <Form.Label>Deduction Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="deductionAmount"
                      value={deductionData.deductionAmount}
                      onChange={handleChange}
                      required
                      placeholder="Enter amount"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="d-flex justify-content-start mt-4">
          <Button type="submit" className="fields-submit" disabled={loading}>
            {loading ? <><Spinner animation="border" size="sm" className="me-2" />Saving...</> : "Save Deduction"}
          </Button>
          <Button
            variant="secondary"
            className="ms-3"
            onClick={() => navigate("/view-deductions")}
          >
            View Deductions
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default DeductionMaster;